module.exports = __webpack_public_path__ + "img/delete.3c086768.svg";